<template>
  <div class="q-pa-xs">
    <AccumulationDistributionComponents
      :isMainChart="true"
      @chartSymbol="
        (eventSymbol) => {
          symbol = eventSymbol;
        }
      "
    />
  </div>
</template>

<script setup>
import { ref, watchEffect } from "vue";
import AccumulationDistributionComponents from "src/components/AccumulationDistributionComponents/AccumulationDistributionComponents.vue";
const emit = defineEmits(["chartSymbol"]);

const symbol = ref("");
watchEffect(() => {
  if (symbol.value && symbol.value !== "") {
    emit("chartSymbol", symbol.value);
  }
});
</script>
